PJQ.inputs.timecards = {}
PJQ.inputs.timecards.TimeCardEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-editor-input'),
        isReadOnly: false,
        onChange: _.noop(),
        onNextField: _.noop(),
        model: null
    },
    events: {
        'click button.edit': 'showDetails'
    },
    beforeFirstRender: function () {
        this.model = this.options.model;

        if (this.model.get('approvedOn') || !(PJQ.app.session.hasPermission('timeCards.canAdd') || (PJQ.app.session.project && PJQ.app.session.project.hasPermission('timeCards.canAdd'))))
            this.options.isReadOnly = true;

    },
    renderData: function () {
        return {
            model: this.model,
            isReadOnly: this.options.isReadOnly
        };
    },
    afterRender: function () {

        this.$('input.hours').inputmask('99', {
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {

            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.hours').val()) == 2) {
                this.$('input.minutes').focus();
            }

        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.hours').select();
        }, this));

        this.$('input.minutes').inputmask('59', {
            positionCaretOnClick: 'select',
            definitions: {
                "5": {
                    validator: "[012345]"
                }
            },
            placeholder: ''
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.minutes').val()) == 2) {
                if (typeof this.options.onNextField === 'function') {
                    this.options.onNextField(this.model);
                }
            }
        }, this)).off("keydown.tei").on("keydown.tei", _.bind(function (e) {
            if (e.which == 9) {
                if (typeof this.options.onNextField === 'function') {
                    this.options.onNextField(this.model);
                }

                e.preventDefault();
            }
        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.minutes').select();
        }, this));

        let totalMinutes = this.model.getTotalTime();
        let hours = parseInt(totalMinutes / 60);
        let minutes = totalMinutes % 60;

        this.$('input.hours').val(hours);
        this.$('input.minutes').val(minutes);
    },
    showDetails: function () {
        new PJQ.views.timecards.TimeCardDetailsModal({
            settings: this.options.settings,
            project: this.options.project,
            model: this.model,
            onSave: _.bind(function () {
                let totalMinutes = this.model.getTotalTime();
                let hours = parseInt(totalMinutes / 60);
                let minutes = totalMinutes % 60;

                this.$('input.hours').val(hours);
                this.$('input.minutes').val(minutes);

                if (typeof this.options.onChange === 'function') {
                    this.options.onChange(this.model);
                }
            }, this)
        });
    },
    valueChanged: function (e) {
        let hours = 0, minutes = 0;

        if (this.$('input.hours').val())
            hours = parseInt(this.$('input.hours').val());

        if (this.$('input.minutes').val())
            minutes = parseInt(this.$('input.minutes').val());

        this.model.set('regularHours', (hours * 60) + minutes);
        this.model.set('overtimeHours', 0);
        this.model.set('doubletimeHours', 0);

        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    },
});

PJQ.inputs.timecards.TimeCardWeekEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-week-input'),
        isReadOnly: false,
        onChange: _.noop(),
        onDelete: _.noop(),
        row: null,
        startDate: null
    },
    events: {
        'click .delete-time-card-week': 'deleteWeek'
    },
    beforeFirstRender: function () {

    },
    renderData: function () {
        return {
            project: this.options.row.project,
            canDelete: _.size(_.filter(this.options.row.models, function (model) {
                return model.get('approvedOn') == null;
            })) > 0 && (PJQ.app.session.hasPermission('timeCards.isAdmin') || (PJQ.app.session.project && PJQ.app.session.project.hasPermission('timeCards.isAdmin')))
        };
    },
    afterRender: function () {
        this.editors = [];

        // iterate through the days, find model for that day and create the control
        for (let i = 0; i < 7; i++) {
            let date = PJQ.helpers.dateHelpers.getNewDateAddDays(this.options.startDate, i);

            _.each(this.options.row.models, _.bind(function (timecard) {
                if (timecard.get('date').getTime() == PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)).getTime()) {
                    this.editors.push(new PJQ.inputs.timecards.TimeCardEditor({
                        el: this.$('div.time-card-day[data-day-column="' + i + '"] div.timecard-editor'),
                        settings: this.options.settings,
                        model: timecard,
                        project: this.options.project,
                        onChange: _.bind(function () {
                            this.calculateWeekTotal();
                        }, this),
                        onNextField: _.bind(function () {
                            if (i < 6) {
                                this.editors[i + 1].$el.find('input.hours').focus();
                            }
                        }, this)
                    }));
                }
            }, this));
        }

        this.calculateWeekTotal();
    },
    getTotalTimeForDate: function (date) {
        let totalMinutes = 0;
        _.each(this.options.row.models, _.bind(function (timecard) {
            if (!timecard.get('deletedOn') && timecard.get('date').getTime() == PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)).getTime())
                totalMinutes += timecard.getTotalTime();
        }, this));

        return totalMinutes;
    },
    calculateWeekTotal: function () {
        let totalMinutes = 0;
        _.each(this.options.row.models, _.bind(function (timecard) {
            if (!timecard.get('deletedOn'))
                totalMinutes += timecard.getTotalTime();
        }, this));

        this.$('.time-card-total').text(PJQ.helpers.timecards.getFormattedTime(totalMinutes));

        if (typeof this.options.onChange === 'function') {
            this.options.onChange();
        }
    },
    hasChanges: function () {
        for (let i = 0; i < _.size(this.options.row.models); i++) {
            let timecard = this.options.row.models[i];
            if (timecard.get('deletedOn') || (!timecard.isNew() && timecard.isDirty)
                || (timecard.isNew() && (_.size(timecard.get('notes')) > 0 || timecard.getTotalTime() > 0))) {
                return true;
            }
        }
        return false;
    },
    isWeekNewAndEmpty: function () {
        let totalMinutes = 0, totalNotes = 0;
        _.each(this.options.row.models, _.bind(function (timecard) {
            if (!timecard.get('deletedOn') && timecard.isNew()) {
                totalMinutes += timecard.getTotalTime();
                totalNotes += _.size(timecard.get('notes'));
            } else {
                // found a not new one
                totalMinutes += 1;
            }
        }, this));

        return (totalMinutes + totalNotes === 0);
    },
    deleteWeek: function () {
        new PJQ.views.modals.YesNo({
            header: "Delete Time Cards",
            body: "Do you want delete time cards for this week for " + this.options.row.project.projectName + "?",
            onYes: _.bind(function () {
                _.each(this.options.row.models, _.bind(function (timecard) {
                    if (!timecard.get('approvedOn'))
                        timecard.set({
                            delete: true,
                            deletedOn: new Date()
                        });
                }, this));

                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete();
                }
            }, this)
        });
    }
});

PJQ.helpers.timecards = {}
PJQ.helpers.timecards.getFormattedTime = function (input) {
    let totalMinutes = input,
        hours = parseInt(totalMinutes / 60),
        minutes = totalMinutes % 60;

    return hours + ':' + ((minutes < 10) ? '0' : '') + minutes;
};

PJQ.inputs.timecards.TimeCardGroupEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-group-editor-input'),
        isReadOnly: false,
        onChange: _.noop(),
        onDelete: _.noop(),
        onNextField: _.noop(),
        model: null
    },
    events: {
        'click .delete-group': 'deleteGroup'
    },
    beforeFirstRender: function () {

    },
    renderData: function () {
        return {
            isReadOnly: this.options.isReadOnly,
            model: this.options.model
        };
    },
    afterRender: function () {
        this.$('input.group-regular-hours').inputmask('99', {
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-regular-hours').val()) == 2)
                this.$('input.group-regular-minutes').focus();
        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.group-regular-hours').select();
        }, this));

        this.$('input.group-overtime-hours').inputmask('99', {
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-overtime-hours').val()) == 2)
                this.$('input.group-overtime-minutes').focus();
        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.group-overtime-hours').select();
        }, this));

        this.$('input.group-doubletime-hours').inputmask('99', {
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-doubletime-hours').val()) == 2)
                this.$('input.group-doubletime-minutes').focus();
        }, this)).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", _.bind(function () {
            this.$('input.group-doubletime-hours').select();
        }, this));

        this.$('input.group-regular-minutes, input.group-overtime-minutes, input.group-doubletime-minutes').inputmask('59', {
            definitions: {
                "5": {
                    validator: "[012345]"
                }
            },
            placeholder: '',
            positionCaretOnClick: 'select'
        }).off("change.tei").on("change.tei", _.bind(function () {
            this.valueChanged();
        }, this)).off("focus.tei").on("focus.tei", function () {
            $(this).select();
        });

        this.$('input.group-regular-minutes').off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-regular-minutes').val()) == 2)
                this.$('input.group-overtime-hours').focus();
        }, this));

        this.$('input.group-overtime-minutes').off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-overtime-minutes').val()) == 2)
                this.$('input.group-doubletime-hours').focus();
        }, this));

        this.$('input.group-doubletime-minutes').off("keyup.tei").on("keyup.tei", _.bind(function (e) {
            if (e.which !== 9 && e.which !== 16 && _.size(this.$('input.group-doubletime-minutes').val()) == 2) {
                if (typeof this.options.onNextField === 'function') {
                    this.options.onNextField(this.options.model);
                }
            }
        }, this)).off("keydown.tei").on("keydown.tei", _.bind(function (e) {
            if (e.which == 9) {
                if (typeof this.options.onNextField === 'function') {
                    this.options.onNextField(this.options.model);
                }
                e.preventDefault();
            }
        }, this));

        this.$('input.group-regular-hours').val((parseInt(this.options.model.get('regularHours') / 60)).toString().padStart(2, '0'));
        this.$('input.group-regular-minutes').val((parseInt(this.options.model.get('regularHours') % 60)).toString().padStart(2, '0'));
        this.$('input.group-overtime-hours').val((parseInt(this.options.model.get('overtimeHours') / 60)).toString().padStart(2, '0'));
        this.$('input.group-overtime-minutes').val((parseInt(this.options.model.get('overtimeHours') % 60)).toString().padStart(2, '0'));
        this.$('input.group-doubletime-hours').val((parseInt(this.options.model.get('doubletimeHours') / 60)).toString().padStart(2, '0'));
        this.$('input.group-doubletime-minutes').val((parseInt(this.options.model.get('doubletimeHours') % 60)).toString().padStart(2, '0'));

        this.$('.group-regular-hours').focus();
    },
    valueChanged: function () {
        if (typeof this.options.onChange == 'function')
            this.options.onChange();
    },
    getValues: function () {
        let regularHours = 0, overtimeHours = 0, doubletimeHours = 0;

        let hours = 0, minutes = 0;

        if (this.$('input.group-regular-hours').val())
            hours = parseInt(this.$('input.group-regular-hours').val());

        if (this.$('input.group-regular-minutes').val())
            minutes = parseInt(this.$('input.group-regular-minutes').val());

        regularHours = (hours * 60) + minutes;

        hours = 0, minutes = 0;

        if (this.$('input.group-overtime-hours').val())
            hours = parseInt(this.$('input.group-overtime-hours').val());

        if (this.$('input.group-overtime-minutes').val())
            minutes = parseInt(this.$('input.group-overtime-minutes').val());

        overtimeHours = (hours * 60) + minutes;

        hours = 0, minutes = 0;

        if (this.$('input.group-doubletime-hours').val())
            hours = parseInt(this.$('input.group-doubletime-hours').val());

        if (this.$('input.group-doubletime-minutes').val())
            minutes = parseInt(this.$('input.group-doubletime-minutes').val());

        doubletimeHours = (hours * 60) + minutes;

        return {
            regularHours: regularHours,
            overtimeHours: overtimeHours,
            doubletimeHours: doubletimeHours
        };
    },
    deleteGroup: function () {
        new PJQ.views.modals.YesNo({
            header: "Delete Trade",
            body: "Do you want delete time for " + this.options.model.get('group').groupName + "?",
            onYes: _.bind(function () {
                this.options.model.set('deletedOn', new Date());

                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.options.model);
                }
            }, this)
        });
    }
});